import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../axiosConfig";
import { toast } from "react-toastify";

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  const getPrivacyPolicy = async () => {
    setLoading(true);
    axiosInstance
      .get(`/setting/detail?type=aboutUsDetails`)
      .then((response) => {
        const { status } = response?.data;
        if (status) {
          setContent(response?.data?.data?.privacyPolicy || "");
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.message);
        setLoading(false);
      });
  };

  return (
    <section
      className="container terms-service"
      style={{ padding: "120px 0px 100px" }}
    >
      <h1 className="mb-4 text-center">Privacy Policy</h1>

      {loading ? (
        <p className="text-center">Loading…</p>
      ) : content ? (
        <div
          className="privacy-policy-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      ) : (
        <p className="text-center">
          Our privacy policy will be available here shortly.
        </p>
      )}
    </section>
  );
};

export default PrivacyPolicy;
